<template>
  <div id="app">
    <h1>Cookie Clickers Helper</h1>
    <UpgradeList
      v-bind:upgrades="upgrades"
      v-bind:nextUpgradeIndex="nextUpgradeIndex"
    />
    <NextUpgrade
      v-bind:upgrades="upgrades"
      v-on:next-upgrade-index="updateNextUpgradeIndex"
    />
  </div>
</template>
<script>
import UpgradeList from "./components/UpgradeList";
import NextUpgrade from "./components/NextUpgrade";

export default {
  name: "app",
  components: {
    UpgradeList,
    NextUpgrade
  },
  methods: {
    getNextPrice: function(upgrade) {
      const { startingPrice, qty } = upgrade;

      return Math.floor(startingPrice * Math.pow(1.3, qty));
    },

    thousandSeparator: function(number) {
      const parts = number.toString().split(".");
      parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },

    updateNextUpgradeIndex: function(newNextUpgradeIndex) {
      this.nextUpgradeIndex = newNextUpgradeIndex;
    }
  },
  watch: {
    upgrades: {
      handler(newVal) {
        localStorage.upgrades = JSON.stringify(newVal);
      },
      deep: true
    }
  },
  mounted() {
    if (localStorage.upgrades) {
      this.upgrades = JSON.parse(localStorage.upgrades);
      return;
    }

    this.upgrades = [
      { name: "Auto click", cps: 0.1, startingPrice: 30, qty: 0 },
      { name: "GrandMa", cps: 0.3, startingPrice: 100, qty: 0 },
      { name: "C-Robot", cps: 1, startingPrice: 1000, qty: 0 },
      { name: "CookieFarm", cps: 3.1, startingPrice: 10000, qty: 0 },
      { name: "C-Factory", cps: 6, startingPrice: 50000, qty: 0 },
      { name: "S-Factory", cps: 20, startingPrice: 200000, qty: 0 },
      { name: "X-Factory", cps: 40, startingPrice: 500000, qty: 0 },
      { name: "C-Cloner", cps: 70, startingPrice: 1000000, qty: 0 },
      { name: "C-Cern", cps: 300, startingPrice: 5000000, qty: 0 },
      { name: "Atomic-C", cps: 1500, startingPrice: 30000000, qty: 0 },
      { name: "Alien Robot", cps: 3000, startingPrice: 70000000, qty: 0 },
      { name: "Alien Labs", cps: 8000, startingPrice: 200000000, qty: 0 },
      { name: "Alien Labs v2", cps: 15000, startingPrice: 400000000, qty: 0 },
      { name: "Alien Tech", cps: 20000, startingPrice: 600000000, qty: 0 },
      { name: "Alien C-X", cps: 30000, startingPrice: 1000000000, qty: 0 },
      { name: "Nano Cookie", cps: 80000, startingPrice: 3000000000, qty: 0 },
      { name: "Molecular-C", cps: 120000, startingPrice: 5000000000, qty: 0 },
      {
        name: "Virus Cookie",
        cps: 200000,
        startingPrice: 10000000000,
        qty: 0
      },
      {
        name: "Proto Cookie",
        cps: 350000,
        startingPrice: 20000000000,
        qty: 0
      },
      { name: "Synaptic C", cps: 600000, startingPrice: 50000000000, qty: 0 },
      {
        name: "Hydrogenic C",
        cps: 1000000,
        startingPrice: 100000000000,
        qty: 0
      },
      {
        name: "Uranium C",
        cps: 1500000,
        startingPrice: 200000000000,
        qty: 0
      },
      {
        name: "Plutonium C",
        cps: 2500000,
        startingPrice: 400000000000,
        qty: 0
      },
      { name: "Krypto-C", cps: 4000000, startingPrice: 800000000000, qty: 0 },
      {
        name: "RedKrypto-C",
        cps: 7000000,
        startingPrice: 1600000000000,
        qty: 0
      },
      { name: "Moon-C", cps: 10000000, startingPrice: 2500000000000, qty: 0 },
      {
        name: "Galaxy-C",
        cps: 15000000,
        startingPrice: 4000000000000,
        qty: 0
      },
      {
        name: "Galaxy-X",
        cps: 25000000,
        startingPrice: 8000000000000,
        qty: 0
      },
      {
        name: "Cookie Hack",
        cps: 40000000,
        startingPrice: 15000000000000,
        qty: 0
      },
      {
        name: "Cookie God",
        cps: 1000000000,
        startingPrice: 1000000000000000,
        qty: 0
      }
    ];
  },
  data() {
    return {
      upgrades: [],
      nextUpgradeIndex: null
    };
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
